import React, { useEffect } from "react";

import {
  FiInfo,
  FiCheckCircle,
  FiAlertCircle,
  FiXCircle,
} from "react-icons/fi";

import { useToast } from "../../../hooks/toast";

import { Container } from "./styles";

const icons = {
  info: <FiInfo size={24} />,
  success: <FiCheckCircle size={24} />,
  warning: <FiAlertCircle size={24} />,
  error: <FiAlertCircle size={24} />,
};

const Toast = ({ message, style }) => {
  const { removeToast } = useToast();

  useEffect(() => {
    const timer = setTimeout(() => {
      removeToast(message.id);
    }, message.time);

    return () => {
      clearTimeout(timer);
    };
  }, [removeToast, message.id, message.time]);

  return (
    <Container
      type={message.type}
      hasdescription={Number(!!message.description)}
      style={style}
    >
      {icons[message.type || "info"]}

      <div>
        <strong>{message.title}</strong>
        {message.description && <p>{message.description}</p>}
      </div>

      <button onClick={() => removeToast(message.id)} type="button">
        <FiXCircle size={18} />
      </button>
    </Container>
  );
};

export default Toast;
